import { styled, useTheme } from '@vebox/etui-system';
import { createElement, useCallback, Fragment, useMemo } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from './_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import ContainerDimensions from './ContainerDimensions/ContainerDimensions.js';
import { T as TreeView } from './TreeView-4d6ddaec.js';

const _excluded = ["theme"];
const TableHeader = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    fontWeight: 'bold',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    flexFlow: 'row wrap'
  }, props);
})``;

const _excluded$1 = ["theme"];
const TableRowCellDiv = styled(Div).attrs(_ref => {
  let props = _objectWithoutProperties(_ref, _excluded$1);
  return _objectSpread2({
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }, props);
})``;

const _excluded$2 = ["onClick", "theme"];
const Th = styled(Div).attrs(_ref => {
  let {
      onClick,
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return _objectSpread2({
    overflow: 'hidden',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSizeSmall,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    textAlign: 'left',
    m: `${theme.spacing.xxs}px`,
    p: `${theme.spacing.xxs}px`
  }, props);
})`
  transition: background 0.2s ease;
  grid-column: ${props => props.column};
  grid-row: ${props => props.row};
`;

const _excluded$3 = ["columns", "data", "width", "styles"];
const BaseTreeViewTable = _ref => {
  let {
      columns,
      data,
      width,
      styles = {}
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$3);
  const theme = useTheme();
  const updateTreeItem = useCallback((item, depth) => {
    if (item.treeTableRows) {
      item.content = /*#__PURE__*/createElement(Fragment, null, item.treeTableRows.map(r => columns.map(({
        key: columnKey,
        width: colWidth
      }, columnIndex) => columnIndex !== 0 ? /*#__PURE__*/createElement(TableRowCellDiv, _extends({
        key: columnKey
      }, styles.table, {
        flex: colWidth || 1,
        ml: `${theme.spacing.xxs}px`,
        pl: `${theme.spacing.xxs}px`,
        overflow: 'visible'
      }), /*#__PURE__*/createElement("div", {
        id: `${item.id}-label`
      }, r[columnKey])) : null)));
    }
    item.items = item.items && item.items.map(subItem => updateTreeItem(subItem, depth + 1));
    return item;
  }, [columns, theme, styles]);
  data = useMemo(() => {
    return data.map(item => updateTreeItem(item, 1));
  }, [data, updateTreeItem]);
  const nestedColumnStyle = {
    styles: {
      row: {
        nestedColumn: {
          flex: columns[0].width || 1
        },
        overflow: 'hidden'
      }
    }
  };
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(TableHeader, _extends({
    width: width,
    columns: columns
  }, styles.tableHeader), columns.map((c, index) => {
    return /*#__PURE__*/createElement(Th, {
      key: c.title,
      row: 1,
      flex: c.width || 1,
      column: index + 1
    }, c.title);
  })), /*#__PURE__*/createElement(TreeView, _extends({
    data: data
  }, _objectSpread2(_objectSpread2({}, styles.treeView), nestedColumnStyle), rest)));
};
const TreeViewTable = props => {
  return /*#__PURE__*/createElement(ContainerDimensions, null, ({
    width
  }) => /*#__PURE__*/createElement(BaseTreeViewTable, _extends({
    width: width
  }, props)));
};

export { TreeViewTable as T, TableHeader as a, TableRowCellDiv as b, Th as c };
